
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gpt-api-ui",
      function () {
        return require("private-next-pages/gpt-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gpt-api-ui"])
      });
    }
  